import React, {Component} from 'react';
import {Typography, CircularProgress, withStyles} from "@material-ui/core";
import {bindActionCreators, compose} from "redux";
import {connect} from "react-redux";
import {withRouter, Redirect} from "react-router-dom";
import {replace} from "react-router-redux";
import {withFirebase, withFirestore} from "react-redux-firebase";

import {messaging} from "../firebase";
import {verifyTokenRequest} from "../redux/reducers/push";

const firebaseMessaging= messaging();

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        zIndex: 1,
    },
    progress: {
        color: '#FFFFFF',
    },
    text: {
        marginTop: theme.spacing.unit*2,
    }
});

class PushRequest extends Component {

    constructor() {
        super();

        this.state = {
            text: 'Vänligen tryck "Tillåt" i aviseringsrutan.',
        }
    }

    async componentDidMount() {
        await this.activate(this.props);
    }

    async componentWillReceiveProps(nextProps) {
        if (
            !!nextProps.tokenVerified && !!nextProps.token && !!nextProps.user.uid &&
            !(!!this.props.tokenVerified && !!this.props.token && !!this.props.user.uid)
        ) {
            await this.subscribe(nextProps);
        }
    }

    async activate(props = this.props) {
        try {
            this.setState({ text: 'Vänligen tryck "Tillåt" i aviseringsrutan.' });
            const user = await this.signIn(props);
            if (!user.uid) {
                return this.onError('auth/no-uid');
            }

            await this.askPermission(props);
            this.setState({ text: 'Förbereder internet' });
            setTimeout(() => this.setState({ text: 'Förbereder internet, det kan ta upp till 30 sekunder.' }), 5000);
        } catch(e) {
            return this.onError(e);
        }
    }

    onError(err) {
        let code = 'PUSH_UNKNOWN_ERROR';
        switch (err.code || err) {
            default:
                code = err.code || err || 'unknown';
                break;
            case 'messaging/permission-blocked':
                code = 'blocked';
                break;
            case 'auth/no-uid':
                code = 'no-uid';
                break;
            case 'TOKEN_INVALID':
                code = 'invalid';
                break;
            case 'TOKEN_VERIFY_TIMEOUT':
                code = 'timeout';
                break;
        }
        return this.props.replace('/error/push/' + code);
    }

    async signIn(props = this.props) {
        const {firebase, user} = props;

        if (!!user.uid) {
            return user;
        }

        const result = await firebase.auth().signInAnonymously();
        return result.user;
    }

    async askPermission(props = this.props) {
        if (!firebaseMessaging) {
            throw new Error('INVALID_BROWSER');
        }
        await firebaseMessaging.requestPermission();
        const token = await firebaseMessaging.getToken();
        if (!token) {
            throw new Error("NO_TOKEN");
        }

        const {verifyTokenRequest} = props;
        verifyTokenRequest(token);
    }

    /*
        Firestore /subscriptions/AP_MAC/clients/CLIENT_MAC = wifi object
     */
    async subscribe(props = this.props) {
        const {token, user, firebase, firestore, wifi: {mac, ap, ssid, time, url}} = props;

        // Maybe get token again to make sure it's the same (or at least still valid and not blocked)
        const document = {
            type: 'PUSH',
            active: true,
            token,
            wifi: {
                mac, ssid, time, url
            },
            uid: user.uid,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        };

        await firestore
            .collection('subscriptions/')
            .doc(ap)
            .collection('/clients')
            .doc(user.uid)
            .set(document);

        this.props.replace('/success');
    }

    render() {
        const {classes} = this.props;

        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            console.debug("Browser doesn't support PushManager or serviceWorker");
            return (<Redirect to="/register/sms" />);
        }

        return (
            <div className={classes.root}>
                <CircularProgress color="inherit" className={classes.progress} size={72}/>
                <Typography variant="body2" align="center" className={classes.text}>
                    {this.state.text}
                </Typography>
            </div>
        );
    }
}

PushRequest.propTypes = {

};

const mapStateToProps = ({firebase, wifi, push}) => ({
    isLoaded: !!firebase.auth.isLoaded,
    isSignedIn: !!firebase.auth.uid,
    hasPermission: false,
    user: firebase.auth,
    wifi,
    token: push.token,
    tokenVerified: push.verified,
    tokenError: push.error,
    tokenLoading: push.loading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    replace,
    verifyTokenRequest
}, dispatch);

export default compose(
    withRouter,
    withFirestore,
    withFirebase,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(PushRequest);



// WEBPACK FOOTER //
// ./src/containers/PushRequest.js